// // Add margin-top to page equal to height of header, on page load
// window.addEventListener("load", onLoadFunction);

// function onLoadFunction(e) {
//     onResizeFunction(e);
//     window.addEventListener("resize", onResizeFunction);
// }

// function onResizeFunction(e) {
//     var h = document.getElementById('site-header').scrollHeight;
//     document.getElementById('panel').style.paddingTop = h + "px";
// }

document.addEventListener(
  "DOMContentLoaded",
  function () {
    // Toggle is-active on navigation
    const burger = document.getElementById("hamburger");
    const nav = document.getElementById("menuIntro");
    const body = document.body;

    if (burger) {
      burger.addEventListener("click", () => {
        burger.classList.toggle("is-active");
        nav.classList.toggle("is-active");
        body.classList.toggle("noscroll");
        burger.setAttribute(
          "aria-expanded",
          burger.getAttribute("aria-expanded") === "false" ? "true" : "false"
        );
      });
    }
  },
  false
);
